import React, { useMemo } from 'react'

import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Box,
  Button,
  Flex,
  Spacer,
  Text,
  useDisclosure,
} from '@chakra-ui/react'
import { useSelector } from 'react-redux'

import ConstituentsDrawer from './ConstituentsDrawer'
import CreateTagModal from './CreateTagModal'
import TagSearchBar from './TagSearchBar'
import TagTable from './TagTable'
import { convertDistrictToNumeric } from '../../../../utils'
import { Loading } from '../../../ui'
import { useTagsContext } from '../ContextProvider/TagsContext'

const TagsManager = () => {
  const user = useSelector(state => state.auth.user)
  const {
    filteredTags,
    tagsByDistrict,
    count,
    isLoading,
    constituentsIsOpen,
    closeConstituentsDrawer,
    selectedTag,
    mode,
  } = useTagsContext()

  const { isOpen, onOpen, onClose } = useDisclosure()
  const tags = useMemo(
    () =>
      user.is_admin
        ? Object.entries(tagsByDistrict).sort(([a], [b]) => a.localeCompare(b))
        : [],
    [tagsByDistrict]
  )

  return (
    <Box>
      <Flex align='center' direction='row' w='100%' gap={3} mb={3}>
        <TagSearchBar />
        <Button onClick={onOpen}>Add New Tag</Button>
      </Flex>

      <Box w='100%' h='70vh' overflowY='auto'>
        {isLoading ? (
          <Loading />
        ) : filteredTags.length === 0 ? (
          <Text fontSize='lg' color='gray.600'>
            No tags found.
          </Text>
        ) : user.is_admin ? (
          <Accordion gap={3} allowToggle>
            {tags.map(([district, tags]) => (
              <AccordionItem
                key={`district-${district}-tags`}
                variant='outline'
                shadow='base'
              >
                <AccordionButton py={2}>
                  <Flex w='full' align='center'>
                    <Text variant='subheading-blue' fontSize='md'>
                      District {convertDistrictToNumeric(district)}
                    </Text>
                    <Spacer />
                    <AccordionIcon />
                  </Flex>
                </AccordionButton>
                <AccordionPanel>
                  <TagTable tags={tags} />
                </AccordionPanel>
              </AccordionItem>
            ))}
          </Accordion>
        ) : (
          <TagTable tags={filteredTags} />
        )}
      </Box>
      <Box align='end'>
        <Text variant='subheading-gray'>{count} tags </Text>
      </Box>

      <CreateTagModal isOpen={isOpen} onClose={onClose} />
      {mode === 'constituents' && selectedTag && (
        <ConstituentsDrawer
          isOpen={constituentsIsOpen}
          onClose={() => {
            closeConstituentsDrawer()
          }}
        />
      )}
    </Box>
  )
}

export default TagsManager
